"use client";
import { Skeleton } from "antd";

export default function HeroSkeleton() {
  return (
    <div data-testid="hero-skeleton" className="hero-skeleton" aria-hidden="true">
      <Skeleton.Image active style={{ width: "100%", height: "100%" }} />
    </div>
  );
}
